/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrUpdateReportOptionDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  ProblemDetails,
  ReportOptionDto,
} from '../models/index';
import {
    CreateOrUpdateReportOptionDtoFromJSON,
    CreateOrUpdateReportOptionDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ReportOptionDtoFromJSON,
    ReportOptionDtoToJSON,
} from '../models/index';

export interface DeleteReportOptionRequest {
    id: string;
}

export interface UpdateReportOptionRequest {
    createOrUpdateReportOptionDto?: CreateOrUpdateReportOptionDto;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     */
    async deleteReportOptionRaw(requestParameters: DeleteReportOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteReportOption().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/report-options/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 204: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ProblemDetailsFromJSON(jsonValue), "ProblemDetails" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async deleteReportOption(requestParameters: DeleteReportOptionRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ReportsApi['deleteReportOptionRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deleteReportOptionRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getReportOptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/report-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ReportOptionDtoFromJSON(jsonValue), "ReportOptionDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ReportOptionDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getReportOption(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ReportsApi['getReportOptionRaw']>>, ReportOptionDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ReportOptionDto;

         const response = this.getReportOptionRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async updateReportOptionRaw(requestParameters: UpdateReportOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/report-options`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateReportOptionDtoToJSON(requestParameters['createOrUpdateReportOptionDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async updateReportOption(requestParameters: UpdateReportOptionRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ReportsApi['updateReportOptionRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.updateReportOptionRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
